import './corporate-non-fi-verification.scss';

import { useCorporateStore } from '@stores/onboarding';
import React, { useCallback } from 'react';

import { CorporateVerificationBase } from '../corporate-verification-base';
import { CORP_STEPS_DNFI, CORP_STEPS_STANDARD, isDNFIIndustry } from './corporate-non-fi-constants';

const CorporateNonFIVerification = () => {
  const stepData = useCorporateStore((s) => s.stepData);
  const completeStep = useCorporateStore((s) => s.completeStep);

  const isDNFI = isDNFIIndustry(stepData[1]?.industry);
  const activeSteps = isDNFI ? CORP_STEPS_DNFI : CORP_STEPS_STANDARD;

  const handleStepComplete = useCallback(
    (step, data) => completeStep(step, data, activeSteps.length),
    [completeStep, activeSteps.length]
  );

  return (
    <CorporateVerificationBase
      className="corp-non-fi-verification"
      useStore={useCorporateStore}
      steps={activeSteps}
      showDDQ={isDNFI}
      onComplete={handleStepComplete}
    />
  );
};

export { CorporateNonFIVerification };
